//auth
export const SET_CREDENTIALS = 'SET_CREDENTIALS';
export const CLEAR_CREDENTIALS = 'CLEAR_CREDENTIALS';

//options
export const UPDATE_OPTIONS = 'UPDATE_OPTIONS';
export const SELECT_DEFAULT_TRANSFORMATIONS = 'SELECT_DEFAULT_TRANSFORMATIONS';
export const CLEAR_OPTIONS = 'CLEAR_OPTIONS';

//media
export const ADD_MEDIA = 'ADD_MEDIA';
export const REMOVE_MEDIA = 'REMOVE_MEDIA';
export const CLEAR_MEDIA = 'CLEAR_MEDIA';

//consoleResponse
export const ADD_RESPONSE = 'ADD_RESPONSE';
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE';
